const f = {
  color: {
    blue: {
      main: "#304ddbff",
      hover: "#263aadff",
      text: "#ffffffff",
      shortcut: {
        background: "#263aadff",
        backgroundHover: "#1c2674ff"
      },
      linked: {
        text: "#304ddbff",
        textHover: "#263aadff"
      },
      outlined: {
        background: "#ffffffff",
        border: "#4176faff",
        borderHover: "#4176faff",
        text: "#304ddbff",
        textHover: "#263aadff",
        hover: "#ebf5ffff",
        textSeamlessHover: "#1c2674ff",
        shortcut: {
          background: "#d1e8ffff",
          backgroundHover: "#d1e8ffff"
        }
      }
    },
    red: {
      main: "#b83525ff",
      hover: "#822824ff",
      text: "#ffffffff",
      shortcut: {
        background: "#822824ff",
        backgroundHover: "#592728ff"
      },
      linked: {
        text: "#b83525ff",
        textHover: "#822824ff"
      },
      outlined: {
        background: "#ffffffff",
        border: "#e54a32ff",
        borderHover: "#e54a32ff",
        text: "#b83525ff",
        textHover: "#822824ff",
        hover: "#fff0e8ff",
        textSeamlessHover: "#822824ff",
        shortcut: {
          background: "#fedfd5ff",
          backgroundHover: "#fedfd5ff"
        }
      }
    },
    green: {
      main: "#2d8556ff",
      hover: "#28704cff",
      text: "#ffffffff",
      shortcut: {
        background: "#28704cff",
        backgroundHover: "#222923ff"
      },
      linked: {
        text: "#222923ff",
        textHover: "#222923ff"
      },
      outlined: {
        background: "#ffffffff",
        border: "#47c47dff",
        borderHover: "#47c47dff",
        text: "#222923ff",
        textHover: "#222923ff",
        hover: "#f2fff0ff",
        textSeamlessHover: "#222923ff",
        shortcut: {
          background: "#e0fcdeff",
          backgroundHover: "#e0fcdeff"
        }
      }
    },
    grey: {
      main: "#7e8e9eff",
      hover: "#556575ff",
      text: "#ffffffff",
      shortcut: {
        background: "#556575ff",
        backgroundHover: "#405261ff"
      },
      linked: {
        text: "#405261ff",
        textHover: "#405261ff"
      },
      outlined: {
        background: "#ffffffff",
        border: "#c8d3deff",
        borderHover: "#abb9c7ff",
        text: "#405261ff",
        textHover: "#405261ff",
        hover: "#f9fafaff",
        textSeamlessHover: "#1d2b36ff",
        shortcut: {
          background: "#f1f3f5ff",
          backgroundHover: "#f1f3f5ff"
        }
      }
    },
    yellow: {
      main: "#a35214ff",
      hover: "#7a4518ff",
      text: "#ffffffff",
      shortcut: {
        background: "#7a4518ff",
        backgroundHover: "#573b23ff"
      },
      linked: {
        text: "#a35214ff",
        textHover: "#7a4518ff"
      },
      outlined: {
        background: "#ffffffff",
        border: "#fabf5aff",
        borderHover: "#e09c24ff",
        text: "#a35214ff",
        textHover: "#7a4518ff",
        hover: "#fff6e5ff",
        textSeamlessHover: "#7a4518ff",
        shortcut: {
          background: "#ffeeccff",
          backgroundHover: "#ffeeccff"
        }
      }
    },
    purple: {
      main: "#9163bfff",
      hover: "#774ba3ff",
      text: "#ffffffff",
      shortcut: {
        background: "#5d407aff",
        backgroundHover: "#48335cff"
      },
      linked: {
        text: "#774ba3ff",
        textHover: "#5d407aff"
      },
      outlined: {
        background: "#ffffffff",
        border: "#774ba3ff",
        borderHover: "#774ba3ff",
        text: "#774ba3ff",
        textHover: "#5d407aff",
        hover: "#f9f2ffff",
        textSeamlessHover: "#48335cff",
        shortcut: {
          background: "#f2e5ffff",
          backgroundHover: "#f2e5ffff"
        }
      }
    },
    aiPurple: {
      main: "#9747fcff",
      hover: "#7935cfff",
      text: "#ffffffff",
      shortcut: {
        background: "#7935cfff",
        backgroundHover: "#5e18b7ff"
      },
      linked: {
        text: "#9747fcff",
        textHover: "#7935cfff"
      },
      outlined: {
        background: "#ffffffff",
        border: "#9747fcff",
        borderHover: "#7935cfff",
        text: "#9747fcff",
        textHover: "#7935cfff",
        hover: "#fcf9ffff",
        textSeamlessHover: "#5e18b7ff",
        shortcut: {
          background: "#fcf9ffff",
          backgroundHover: "#fcf9ffff"
        }
      }
    },
    greenLight: {
      main: "#e0fcdeff",
      hover: "#b9edbdff",
      text: "#222923ff",
      outlined: {
        background: "#ffffffff",
        border: "#47c47dff",
        borderHover: "#47c47dff",
        text: "#222923ff",
        textHover: "#222923ff",
        hover: "#f2fff0ff",
        textSeamlessHover: "#222923ff",
        shortcut: {
          background: "#e0fcdeff",
          backgroundHover: "#e0fcdeff"
        }
      }
    },
    greyLight: {
      main: "#f1f3f5ff",
      hover: "#dfe6ebff",
      text: "#131b24ff",
      outlined: {
        background: "#ffffffff",
        border: "#c8d3deff",
        borderHover: "#abb9c7ff",
        text: "#405261ff",
        textHover: "#405261ff",
        hover: "#f9fafaff",
        textSeamlessHover: "#1d2b36ff",
        shortcut: {
          background: "#f1f3f5ff",
          backgroundHover: "#f1f3f5ff"
        }
      }
    },
    blueLight: {
      main: "#ebf5ffff",
      hover: "#d1e8ffff",
      text: "#304ddbff",
      outlined: {
        background: "#ffffffff",
        border: "#4176faff",
        borderHover: "#4176faff",
        text: "#304ddbff",
        textHover: "#263aadff",
        hover: "#ebf5ffff",
        textSeamlessHover: "#1c2674ff",
        shortcut: {
          background: "#d1e8ffff",
          backgroundHover: "#d1e8ffff"
        }
      }
    },
    blueAccent: {
      main: "#d1e8ffff",
      hover: "#9ecbffff",
      text: "#131b24ff",
      outlined: {
        background: "#ffffffff",
        border: "#4176faff",
        borderHover: "#4176faff",
        text: "#304ddbff",
        textHover: "#263aadff",
        hover: "#ebf5ffff",
        textSeamlessHover: "#1c2674ff",
        shortcut: {
          background: "#d1e8ffff",
          backgroundHover: "#d1e8ffff"
        }
      }
    },
    redAccent: {
      main: "#ffc7d3ff",
      hover: "#FFB3C3",
      text: "#131b24ff",
      outlined: {
        background: "#ffffffff",
        border: "#e54a32ff",
        borderHover: "#e54a32ff",
        text: "#b83525ff",
        textHover: "#822824ff",
        hover: "#fff0e8ff",
        textSeamlessHover: "#822824ff",
        shortcut: {
          background: "#fedfd5ff",
          backgroundHover: "#fedfd5ff"
        }
      }
    },
    greenAccent: {
      main: "#56f09eff",
      hover: "#31E284",
      text: "#131b24ff",
      outlined: {
        background: "#ffffffff",
        border: "#47c47dff",
        borderHover: "#47c47dff",
        text: "#222923ff",
        textHover: "#222923ff",
        hover: "#f2fff0ff",
        textSeamlessHover: "#222923ff",
        shortcut: {
          background: "#e0fcdeff",
          backgroundHover: "#e0fcdeff"
        }
      }
    },
    disabled: {
      main: "#abb9c7ff",
      text: "#ffffffff",
      outlined: {
        background: "#ffffffff",
        border: "#abb9c7ff",
        text: "#abb9c7ff",
        shortcut: {
          background: "#f1f3f5ff",
          text: "#7e8e9eff"
        }
      },
      shortcut: {
        background: "#7e8e9eff",
        text: "#ffffffff"
      }
    }
  },
  radius: {
    small: "6px",
    default: "8px"
  }
};
export {
  f as button
};
